import { createAsyncThunk } from '@reduxjs/toolkit';
import scheduleApi from '~/apis/schedule';
import {
  EXPORT_SCHEDULE,
  GET_LIST_SCHEDULE,
  CHANGE_EVENT_SCHEDULE,
  REVERT_SCHEDULE_TO_JOB,
} from '~/utils/constants/actionType';
import { IChangeEventSchedule, IQueryParamSchedule } from '~/utils/interface/schedule';

export const getListSchedule = createAsyncThunk(
  GET_LIST_SCHEDULE,
  async (params: IQueryParamSchedule, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.getListSchedule(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportSchedule = createAsyncThunk(
  EXPORT_SCHEDULE,
  async (params: IQueryParamSchedule, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.exportSchedule(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeEventSchedule = createAsyncThunk(
  CHANGE_EVENT_SCHEDULE,
  async (body: IChangeEventSchedule, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.changeEventSchedule(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const revertScheduleToJob = createAsyncThunk(
  REVERT_SCHEDULE_TO_JOB,
  async (scheduleId: string, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.revertScheduleToJob(scheduleId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
